import React from "react";
import {Container} from 'react-bootstrap'
import './Table.css'
import { AllCommunityModule, ModuleRegistry, QuickFilterModule, TextEditorModule, TooltipModule, CheckboxEditorModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import Filtro from "./Filtro";

ModuleRegistry.registerModules([AllCommunityModule, QuickFilterModule, TextEditorModule, TooltipModule, CheckboxEditorModule]);

export default function GridExample ({columns, data, onCellEditingStopped, canCreate, createHook, gridRef, descarga= false}) {
  
  const {quickFilterMatcher, quickFilterParser, onFilterTextBoxChanged} = Filtro(gridRef)
  const defaultColDef = {
    tooltipComponent: "agTooltipComponent",
    flex: 1,
  };

  const exportToCsv = () => {
    gridRef.current.api.exportDataAsCsv({
      processCellCallback: (params) => {
        if (params.column.getColId() === "createdAt") {
          return `${new Date(params.value).toLocaleDateString("en-GB")} ${new Date(params.value).toLocaleTimeString("en-GB")}`;
        }
        return params.value;
      }
    });
  };

  return (
    <Container className="pt-3">
      <div style={{ width: "100%", height: "75vh" }}>
        <div className="example-header">
          {canCreate?.canCreate ? <button className="btn btn-outline-grey mb-2" onClick={()=>{createHook(gridRef)}}>{canCreate?.button}</button> : <></>}
          <input
            type="text"
            id="filter-text-box"
            placeholder="Buscar..."
            className="mb-2"
            onInput={onFilterTextBoxChanged}
          />
          {descarga ? <button className="btn btn-outline-grey ms-2 mb-2" onClick={exportToCsv}>Descargar</button> : <></>}
        </div>
        <AgGridReact
          ref={gridRef}
          rowData={data}
          columnDefs={columns}
          defaultColDef={defaultColDef}
          pagination={true}
          quickFilterParser={quickFilterParser}
          quickFilterMatcher={quickFilterMatcher}
          onCellEditingStopped={(e)=>{onCellEditingStopped(e,gridRef)}}
          gridOptions={{tooltipShowDelay: 100,tooltipHideDelay: 5000}}
        />
      </div>
    </Container>
    
  );
};